import { render, staticRenderFns } from "./SessionInfoDialog.vue?vue&type=template&id=53d70980&scoped=true&"
import script from "./SessionInfoDialog.vue?vue&type=script&lang=ts&"
export * from "./SessionInfoDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SessionInfoDialog.vue?vue&type=style&index=0&id=53d70980&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d70980",
  null
  
)

export default component.exports